interface ShowHideType {
  operator: string;
  numberInput: string | number;
  dataType: string;
  funcNum: string;
  showNum: boolean;
  measureName: string;
  isShow: boolean;
}

const defaultShowHide: ShowHideType = {
  operator: '> Greater than',
  numberInput: '',
  dataType: '',
  funcNum: 'Numb',
  showNum: true,
  measureName: '',
  isShow: true,
};

export function initializeShowHide(chartControls: any, propKey: string | number): void {
  if (!chartControls.properties[propKey].showHide) {
    chartControls.properties[propKey].showHide = { ...defaultShowHide };
  }
}
